// import { Product,Request } from "../redux/AllocationRequest";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Product,Request } from "../redux/AllocationRequest";
import { CartAllocationMap, CartChannelCart, CartChannelProduct, ProductInventoryData } from "../redux/allocationService";
import { DeliverySession } from "../redux/cartSlice";


export const DELIVERY_TIME = [
  { label: "5 min", value: 5 },
  { label: "10 min", value: 10 },
  { label: "15 min", value: 15 },
  { label: "30 min", value: 30 },
  { label: "1 Hour", value: 60 },
];

export const Restaurant_TYPE = [
  { value: "Italian", label: "Italian" },
  { value: "Chinese", label: "Chinese" },
  { value: "Japanese", label: "Japanese" },
  { value: "Indian", label: "Indian" },
];

export const ORDERS_STATUS = [
  { value: "All", label: "All" },
  { value: "Pending", label: "Pending" },
  { value: "AcceptedByCart", label: "Accepted By Cart" },
  { value: "ApprovedByRestaurant", label: "Approved By Restaurant" },
  { value: "Preparing", label: "Preparing" },
  { value: "Collecting", label: "Collecting" },
  { value: "ReadyAtKitchen", label: "Ready At Kitchen" },
  { value: "ArrivedAtCart", label: "Arrived At Cart" },
  { value: "Completed", label: "Completed" },
  { value: "Cancelled", label: "Cancelled" },
  { value: "Tentative", label: "Tentative" },
];

export const EXSAMPALE_ORDER_LIST = [
  {
    orderNumber: "123-487-54",
    itemName: "Rice",
    itemImage:
      "https://landofkingscafe.com/wp-content/uploads/2022/01/Mixed-Rice-II-DSC07353.jpg",
    quntity: 2,
    deliveryTime: "12.30",
    orderStatus: "Preparing",
    cartOrder: false,
  },
  {
    orderNumber: "123-487-54",
    itemName: "Rice",
    itemImage:
      "https://landofkingscafe.com/wp-content/uploads/2022/01/Mixed-Rice-II-DSC07353.jpg",
    quntity: 2,
    deliveryTime: "12.30",
    orderStatus: "Preparing",
    cartOrder: false,
  },
  {
    orderNumber: "123-487-54",
    itemName: "Rice",
    itemImage:
      "https://landofkingscafe.com/wp-content/uploads/2022/01/Mixed-Rice-II-DSC07353.jpg",
    quntity: 2,
    deliveryTime: "12.30",
    orderStatus: "Preparing",
    cartOrder: false,
  },
];

export const options = [
  {
    id: "3RWR9ABoSlaMdgnXJOfe",
    label: "Mushroom Rice",
    description: "mushroom rice.",
    imageUrl:
      "https://storage.googleapis.com/fooddelivery-7eac6.appspot.com/Restaurants/OSDCRWsOKwKvTEgLF31m/MenuItems/50ba58ae-8a1a-4e6f-9d76-b30f13278955.jpg",
    price: 230
  },
  {
    id: "9BggQtEUajhBQK1d9Oi4",
    label: "Chocolate chips cookie",
    description: "chocolate chipe cookies.",
    imageUrl:
      "https://storage.googleapis.com/fooddelivery-7eac6.appspot.com/Restaurants/OSDCRWsOKwKvTEgLF31m/MenuItems/54330cff-094a-4672-bf6b-30c9c803e584.jpg",
    price: 340
  },
  {
    id: "FiWNg1Ec9bRXn3IcoaML",
    label: "Chocolate",
    description:
      "Chocolate desserts",
    imageUrl:
      "https://storage.googleapis.com/fooddelivery-7eac6.appspot.com/Restaurants/OSDCRWsOKwKvTEgLF31m/MenuItems/4503c7da-c544-4b24-9888-ac5e8f97c77d.jpg"
    ,
    price: 670
  },
  {
    id: "GMNqTf0rATS2Num6M4Yj",
    label: "Chicken Cury",
    description:
      "Fresh romaine lettuce, croutons, parmesan cheese, and Caesar dressing.",
    imageUrl:
      "https://storage.googleapis.com/fooddelivery-7eac6.appspot.com/Restaurants/OSDCRWsOKwKvTEgLF31m/MenuItems/c1cb1908-9a85-4ec0-b5fb-2a42aadc1643.jpg",
    price: 520
  },
  {
    id: "idchPIu16J6E7sNZmnvn",
    label: "Watalappan",
    description:
      "Watalappan recipe",
    imageUrl:
      "https://storage.googleapis.com/fooddelivery-7eac6.appspot.com/Restaurants/OSDCRWsOKwKvTEgLF31m/MenuItems/a92261be-9105-457c-ab25-01c727f83e83.jpg",
    price: 520
  },
  {
    id: "mjWunXbldnpENKjH5rR5",
    label: "String Hoppers",
    description:
      "Fresh romaine lettuce, croutons, parmesan cheese, and Caesar dressing.",
    imageUrl:
      "https://storage.googleapis.com/fooddelivery-7eac6.appspot.com/Restaurants/OSDCRWsOKwKvTEgLF31m/MenuItems/45d43bee-3975-4938-b7d5-d7a2d9eb00fe.jpg"
    ,
    price: 520
  },

];

export const categories = [
  { id: 1, name: "Vegan" },
  { id: 2, name: "Desserts" },
  { id: 3, name: "Sri Lankan" },
  { id: 4, name: "Ice Cream" },
  { id: 5, name: "Japanese" },
  { id: 6, name: "Healthy" },
  { id: 7, name: "Bubble" },
];

export const Graphdata12Months = [
  ["Month", "Sales"],
  ["Jan", 1000],
  ["Feb", 1170],
  ["Mar", 660],
  ["Apr", 1030],
  ["May", 980],
  ["Jun", 700],
  ["Jul", 860],
  ["Aug", 940],
  ["Sep", 1020],
  ["Oct", 1000],
  ["Nov", 1080],
  ["Dec", 1100],
];

export const Graphdata3Months = [
  ["Month", "Sales"],
  ["Oct", 1000],
  ["Nov", 1080],
  ["Dec", 1100],
];

export const Graphdata30Days = [
  ["Day", "Sales"],
  ["1", 200],
  ["5", 300],
  ["10", 350],
  ["15", 400],
  ["20", 450],
  ["25", 500],
  ["30", 550],
];

export const Graphdata7Days = [
  ["Day", "Sales"],
  ["1", 40],
  ["2", 50],
  ["3", 140, 60],
  ["4", 160, 70],
  ["5"],
  ["6", 90],
  ["7", 100],
];

export const Graphdata24Hours = [
  ["Hour", "Sales"],
  ["00", 10],
  ["06", 20],
  ["12", 30],
  ["18", 40],
  ["24", 50],
];

export const optionsForGraph = {
  title: 'Company Performance',
  curveType: 'function',
  legend: { position: 'bottom' },
};

// Define the type for options
export interface OptionType {
  value: string;
  label: string;
}
export const CustomizedOptions: OptionType[] = [
  { value: 'rice', label: 'Rice' },
  { value: 'curry', label: 'Curry' },
  { value: 'desserts', label: 'Desserts' },
  { value: 'hoppers', label: 'Hoppers' },
];

export const dineType = [
  { value: "Single", label: "Single" },
  { value: "Custom", label: "Custom" },
  { value: "Set", label: "Set" },
];

export const dineTypeForMenu = [
  { value: "All", label: "All" },
  { value: "Breakfast", label: "Breakfast" },
  { value: "Brunch", label: "Brunch" },
  { value: "Lunch", label: "Lunch" },
  { value: "Dinner", label: "Dinner" },
];

export const menuItemsOptionsForMenu = [
  {
    label: "Fried chicken",
    displayName: "Fried chicken",
    price: 800,
    itemId: "qwedf56yhTG",
    itemType: "Single",
  },
  {
    label: "Grilled Salmon",
    displayName: "Grilled Salmon",
    price: 1800,
    itemId: "tyh67HJU456",
    itemType: "Single",
  },
  {
    label: "Margherita Pizza",
    displayName: "Margherita Pizza",
    price: 670,
    itemId: "iuy87hGF345",
    itemType: "Single",
  },
  {
    label: "Caesar Salad",
    displayName: "Caesar Salad",
    price: 2800,
    itemId: "poi98BVC123",
    itemType: "Single",
  },
];

export const MenuTypeForMenu = [
  { value: "All", label: "All" },
  { value: "Single", label: "Menu Item" },
  { value: "SetMenu", label: "Set Menu" },
  { value: "CustomMenu", label: "Custom Menu" }
];

export const OrderPersonType = [
  { value: "CartPerson", label: "Cart" },
  { value: "User", label: "Customer" },
  { value: "Organization", label: "Organization" },
];

export const OrderTime = [
  { value: "06:30 AM - 07:30 AM", label: "06:30 AM - 07:30 AM" },
  { value: "07:30 AM - 08:30 AM", label: "07:30 AM - 08:30 AM" },
  { value: "08:30 AM - 09:30 AM", label: "08:30 AM - 09:30 AM" },
  { value: "09:30 AM - 10:30 AM", label: "10:30 AM - 11:30 AM" },
  { value: "11:30 AM - 12:30 PM", label: "11:30 AM - 12:30 PM" },
  { value: "12:30 PM - 01:30 PM", label: "12:30 PM - 01:30 PM" },
  { value: "01:30 PM - 02:30 PM", label: "01:30 PM - 02:30 PM" },
  { value: "02:30 PM - 03:30 PM", label: "02:30 PM - 03:30 PM" },
  { value: "03:30 PM - 04:30 PM", label: "03:30 PM - 04:30 PM" },
  { value: "04:30 PM - 05:30 PM", label: "04:30 PM - 05:30 PM" },
  { value: "05:30 PM - 06:30 PM", label: "05:30 PM - 06:30 PM" },
  { value: "06:30 PM - 07:30 PM", label: "07:30 PM - 08:30 PM" },
];

export const PaymentMethod = [
  { value: "Cash", label: "Cash" },
  // { value: "Card", label: "Card", isDisabled: true },
  { value: "Credit", label: "Credit" },
  { value: "CardOnDelivery", label: "Card On Delivery" },
  { value: "BankTransfer", label: "Bank Transfer" }
]
export const USER_TYPE = [
  { value: "All", label: "All" },
  { value: "Cart", label: "Cart" },
  { value: "Customer", label: "Customer" },
  { value: "Restaurant", label: "Restaurant" }
]

export const FLOW_TYPE = [
  { value: "OnDemand", label: "On Demand" },
  { value: "PrePacked", label: "Pre Packed" },
];

export const cartChannelCarts: CartChannelCart[] = [
  { id: 'slic', name: 'SLIC', type: 'fixed' },
  { id: 'park', name: 'Park', type: 'fixed' },
  { id: 'basl', name: 'BASL', type: 'fixed' },
  { id: 'hq', name: 'HQ', type: 'hq' },
  { id: 'del1', name: 'Del-1', type: 'delivery' },
  { id: 'del2', name: 'Del-2', type: 'delivery' },
];

export const cartChannelProducts: CartChannelProduct[] = [
  {
    sku: 'CK0014-L',
    name: 'Chicken Rice & Curry Gold',
    size: 'LARGE',
    tier: 'gold',
  },
  {
    sku: 'CK0014-R',
    name: 'Chicken Rice & Curry Gold',
    size: 'REGULAR',
    tier: 'gold',
  },
  { 
    sku: 'FISH-L', 
    name: 'Fish Rice & Curry', 
    size: 'LARGE', 
    tier: 'platinum' 
  },
  { 
    sku: 'RICE-R', 
    name: 'Steamed Rice', 
    size: 'REGULAR', 
    tier: 'bronze' 
  },
  { 
    sku: 'VEG-R', 
    name: 'Vegetable Curry', 
    size: 'REGULAR', 
    tier: 'bronze' 
  },
];

export const cartChannelAllocations: CartAllocationMap = {
  'CK0014-L': { slic: 40, park: 35, basl: 30, hq: 50, del1: 45, del2: 35 },
  'CK0014-R': { slic: 60, park: 55, basl: 50, hq: 70, del1: 65, del2: 55 },
  'FISH-L': { slic: 30, park: 28, basl: 25, hq: 40, del1: 35, del2: 32 },
  'RICE-R': { slic: 50, park: 45, basl: 40, hq: 60, del1: 55, del2: 50 },
  'VEG-R': { slic: 45, park: 40, basl: 35, hq: 55, del1: 50, del2: 45 },
};

export const initialCartChannelData = {
  'CK0014-L': {
    slic: {
      webReserved: 25,
      walkIn: 12,
      onRoute: 3,
      webDelivery: 0,
      whatsappDelivery: 0,
    },
    park: {
      webReserved: 20,
      walkIn: 12,
      onRoute: 3,
      webDelivery: 0,
      whatsappDelivery: 0,
    },
    basl: {
      webReserved: 18,
      walkIn: 10,
      onRoute: 2,
      webDelivery: 0,
      whatsappDelivery: 0,
    },
    hq: {
      webReserved: 5,
      walkIn: 3,
      onRoute: 0,
      webDelivery: 35,
      whatsappDelivery: 7,
    },
    del1: {
      webReserved: 0,
      walkIn: 0,
      onRoute: 0,
      webDelivery: 35,
      whatsappDelivery: 10,
    },
    del2: {
      webReserved: 0,
      walkIn: 0,
      onRoute: 0,
      webDelivery: 28,
      whatsappDelivery: 7,
    },
  },
};


export const inventoryProducts: ProductInventoryData[] = [
  {
    id: "ck0014-r",
    sku: "CK0014-R",
    name: "Chicken Rice & Curry",
    size: "REGULAR",
    tier: "gold",
    production: { total: 170, c1: 50, c2: 70, c3: 50 },
    allocated: 138,
    orders: { advance: 45, sameDay: 20 },
    available: 7,
    channels: {
      web: { allocated: 83, ordered: 38, available: 45 },
      walkin: { allocated: 31, ordered: 5, available: 26 },
      route: { allocated: 10, ordered: 12, available: -2 },
      webDelivery: { allocated: 57, ordered: 16, available: 41 },
      whatsapp: { allocated: 27, ordered: 9, available: 18 },
    },
    carts: {
      slic: {
        allocated: 30,
        channels: {
          web: { allocated: 20, ordered: 12, available: 8 },
          walkin: { allocated: 7, ordered: 2, available: 5 },
          route: { allocated: 3, ordered: 5, available: -2 },
        },
      },
      park: {
        allocated: 28,
        channels: {
          web: { allocated: 18, ordered: 8, available: 10 },
          walkin: { allocated: 8, ordered: 1, available: 7 },
          route: { allocated: 2, ordered: 3, available: -1 },
        },
      },
      basl: {
        allocated: 25,
        channels: {
          web: { allocated: 15, ordered: 6, available: 9 },
          walkin: { allocated: 8, ordered: 1, available: 7 },
          route: { allocated: 2, ordered: 2, available: 0 },
        },
      },
      hq: {
        allocated: 35,
        channels: {
          web: { allocated: 5, ordered: 3, available: 2 },
          walkin: { allocated: 3, ordered: 1, available: 2 },
          webDelivery: { allocated: 20, ordered: 10, available: 10 },
          whatsapp: { allocated: 7, ordered: 3, available: 4 },
        },
      },
      del1: {
        allocated: 20,
        channels: {
          webDelivery: { allocated: 12, ordered: 6, available: 6 },
          whatsapp: { allocated: 8, ordered: 3, available: 5 },
        },
      },
    },
  },
  {
    id: "ck0014-r",
    sku: "CK0014-R",
    name: "Chicken Rice & Curry",
    size: "REGULAR",
    tier: "gold",
    production: { total: 170, c1: 50, c2: 70, c3: 50 },
    allocated: 138,
    orders: { advance: 45, sameDay: 20 },
    available: 7,
    channels: {
      web: { allocated: 83, ordered: 38, available: 45 },
      walkin: { allocated: 31, ordered: 5, available: 26 },
      route: { allocated: 10, ordered: 12, available: -2 },
      webDelivery: { allocated: 57, ordered: 16, available: 41 },
      whatsapp: { allocated: 27, ordered: 9, available: 18 },
    },
    carts: {
      slic: {
        allocated: 30,
        channels: {
          web: { allocated: 20, ordered: 12, available: 8 },
          walkin: { allocated: 7, ordered: 2, available: 5 },
          route: { allocated: 3, ordered: 5, available: -2 },
        },
      },
      park: {
        allocated: 28,
        channels: {
          web: { allocated: 18, ordered: 8, available: 10 },
          walkin: { allocated: 8, ordered: 1, available: 7 },
          route: { allocated: 2, ordered: 3, available: -1 },
        },
      },
      basl: {
        allocated: 25,
        channels: {
          web: { allocated: 15, ordered: 6, available: 9 },
          walkin: { allocated: 8, ordered: 1, available: 7 },
          route: { allocated: 2, ordered: 2, available: 0 },
        },
      },
      hq: {
        allocated: 35,
        channels: {
          web: { allocated: 5, ordered: 3, available: 2 },
          walkin: { allocated: 3, ordered: 1, available: 2 },
          webDelivery: { allocated: 20, ordered: 10, available: 10 },
          whatsapp: { allocated: 7, ordered: 3, available: 4 },
        },
      },
      del1: {
        allocated: 20,
        channels: {
          webDelivery: { allocated: 12, ordered: 6, available: 6 },
          whatsapp: { allocated: 8, ordered: 3, available: 5 },
        },
      },
    },
  },
];

export const deliverySessions: DeliverySession[] = [
  {
    createdAt: "February 16, 2026 at 3:27:40 PM UTC+5:30",
    deliveryDistance: 12,
    deliveryEndIndex: 1,
    deliveryEndTime: "February 16, 2026 at 3:42:11 PM UTC+5:30",
    deliveryStartIndex: 0,
    deliveryStartTime: "February 16, 2026 at 3:27:40 PM UTC+5:30",
    groupOrderId: "03bRattuBMAEd5aNZ6be",
    id: "QrVi60xbhjWqs76pP8uX",
    isActive: false,
    locationPoints: [
      { lat: 6.4224261, lng: 77.957911 },
      { lat: 7.4224261, lng: 68.957911 },
      { lat: 8.4224261, lng: 68.957911 },
    ],
    sessionEndPoint: { lat: 8.4224261, lng: 68.957911 },
    sessionEndTime: "February 16, 2026 at 4:02:47 PM UTC+5:30",
    sessionStartPoint: { lat: 6.4224261, lng: 77.957911 },
    sessionStartTime: "February 16, 2026 at 3:27:40 PM UTC+5:30",
    totalDistance: 13,
  },
  {
    createdAt: "February 15, 2026 at 9:10:22 AM UTC+5:30",
    deliveryDistance: 24,
    deliveryEndIndex: 2,
    deliveryEndTime: "February 15, 2026 at 9:38:00 AM UTC+5:30",
    deliveryStartIndex: 0,
    deliveryStartTime: "February 15, 2026 at 9:10:22 AM UTC+5:30",
    groupOrderId: "AB9KpqLmXW3rDs8tYc12",
    id: "3aXKL99p2mVYsDEuhkPN",
    isActive: false,
    locationPoints: [
      { lat: 6.9286989, lng: 79.8497445 },
      { lat: 6.9270800, lng: 79.8619325 },
      { lat: 6.9100000, lng: 79.8750000 },
    ],
    sessionEndPoint: { lat: 6.9100000, lng: 79.8750000 },
    sessionEndTime: "February 15, 2026 at 9:44:10 AM UTC+5:30",
    sessionStartPoint: { lat: 6.9286989, lng: 79.8497445 },
    sessionStartTime: "February 15, 2026 at 9:10:22 AM UTC+5:30",
    totalDistance: 31,
  },
  {
    createdAt: "February 14, 2026 at 2:05:00 PM UTC+5:30",
    deliveryDistance: 11,
    deliveryEndIndex: 1,
    deliveryEndTime: "February 14, 2026 at 2:20:00 PM UTC+5:30",
    deliveryStartIndex: 0,
    deliveryStartTime: "February 14, 2026 at 2:05:00 PM UTC+5:30",
    groupOrderId: "ZX7MnbVcQP2wEr4uHj56",
    id: "9zRQM44b7nWZtFGvjlCX",
    isActive: true,
    locationPoints: [
      { lat: 7.8024261, lng: 69.557911 },
      { lat: 7.6224261, lng: 70.257911 },
      { lat: 7.4024261, lng: 71.057911 },
    ],
    sessionEndPoint: { lat: 7.4024261, lng: 71.057911 },
    sessionEndTime: "February 14, 2026 at 2:28:45 PM UTC+5:30",
    sessionStartPoint: { lat: 7.8024261, lng: 69.557911 },
    sessionStartTime: "February 14, 2026 at 2:05:00 PM UTC+5:30",
    totalDistance: 15,
  },
];

export const initialRequests: Request[] = [
  { id: "REQ-006", type: "Product Quantity", department: "Sales & Marketing", requester: "Samantha Perera", summary: "1 product(s), 1 units", targetDate: "2026-03-12", status: "Pending" },
  { id: "REQ-001", type: "Product Quantity", department: "Sales & Marketing", requester: "Samantha Perera", summary: "2 product(s), 80 units", targetDate: "2026-03-24",  status: "Pending" },
  { id: "REQ-002", type: "Cart Allocation", department: "Distribution", requester: "Kumar Silva", summary: "1 cart(s), 35 units", targetDate: "2026-03-23", status: "Pending" },
  { id: "REQ-003", type: "Special Event", department: "Sales & Marketing", requester: "Nimal Fernando", summary: "ABC Corp Annual Lunch - 100 attendees", targetDate: "2026-03-28",  status: "Approved" },
  { id: "REQ-004", type: "Product Quantity", department: "Distribution", requester: "Anjali Dias", summary: "1 product(s), 20 units", targetDate: "2026-03-22",  status: "Rejected" },
  { id: "REQ-005", type: "Cart Allocation", department: "Distribution", requester: "Ravi Jayawardena", summary: "1 cart(s), 25 units", targetDate: "2026-03-25", status: "Pending" },
];
